export const JOB_LIST_DEFAULTS: Record<string, string> = {
  tab: 'all',
  search_term: '',
  priority_id: 'all',
  // Work-order status filter: comma-joined status ids; 'all' = no filter. Only
  // applied on tabs that don't already impose a status (the "All" and "More Info
  // Requested" tabs) — see JobListFilters/JobList (WRK-5781).
  work_order_status_id: 'all',
  job_category_id: 'all',
  // PSR (vulnerable customer) filter: 'all' = no filter, 'true' = only PSR jobs.
  psr: 'all',
  page: '1',
  // Empty = "no explicit sort" → backend default ordering (created_time DESC).
  // useUrlFilters omits empty values from the URL, so an unsorted view has a clean URL.
  sort_by: '',
  sort_order: '',
};

/** Fixed page size for the Jobs list (no rows-per-page selector — matches Users). */
export const JOBS_PAGE_SIZE = 50;
